import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { slugify } from '../../../utils/slugify';
import { ServerVarsContext } from '../../../global/ServerVarsContext/ServerVarsContext';

//components
import { FormattedNumber } from 'react-intl';
import { Checkbox } from 'dibs-elements/exports/Checkbox';
import { AbsoluteAnchor } from '../../../global/AbsoluteAnchor/AbsoluteAnchor';

// styles
import styles from './SbSharedRefineMenuInput.scss';

export function SbSharedRefineMenuInputCheckbox(props) {
    const {
        text,
        count,
        className,
        value,
        checked,
        onChange,
        linkReference,
        linkable,
        isHidden,
        isDisabled,
    } = props;
    const { isSbTopNavVariant } = useContext(ServerVarsContext);
    const containerClass = classnames(styles.container, className, {
        'is-hidden': isHidden,
    });
    const anchorClass = classnames(styles.input, { [styles.disabled]: isDisabled });
    const shouldDisplayCount = typeof count === 'number' && !isSbTopNavVariant;

    return (
        <div className={containerClass}>
            <AbsoluteAnchor
                linkReference={linkReference}
                linkable={linkable}
                className={anchorClass}
                onClick={e => e.preventDefault()}
            >
                <div onClick={e => e.stopPropagation()}>
                    <Checkbox
                        labelClass={styles.text}
                        value={value}
                        checked={checked}
                        name={text}
                        label={text}
                        onChange={onChange}
                        disabled={isDisabled}
                        dataTn={`facet-content-${slugify(text)}`}
                    />
                </div>
            </AbsoluteAnchor>
            {shouldDisplayCount && (
                <span className={styles.count} data-tn={`facet-count-${slugify(text)}`}>
                    <FormattedNumber value={count} />
                </span>
            )}
        </div>
    );
}

SbSharedRefineMenuInputCheckbox.propTypes = {
    count: PropTypes.number,
    text: PropTypes.string.isRequired,
    className: PropTypes.string,
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    linkReference: PropTypes.string,
    linkable: PropTypes.bool,
    isHidden: PropTypes.bool,
    isDisabled: PropTypes.bool,
};
